<div class="container-fluid" style="height: calc(100% - 50px); padding: 20px;">
    <div style="height: calc(100% - 100px)">
        <!-- Single state display - handles both loading and empty -->
        <app-state-display
            *ngIf="isLoading || (!isLoading && reportQueue.length === 0)"
            [type]="isLoading ? 'loading' : 'empty'"
            loadingMessage="Loading report queue..."
            emptyMessage="No report queue found"
            emptyIcon="assignment">
        </app-state-display>

        <!-- Table content -->
        <app-custom-table
            *ngIf="!isLoading && reportQueue.length > 0"
            class="ag-theme-material"
            [rowData]="reportQueue"
            [columnDefs]="columnDefs"
            [animateRows]="true"
            [pagination]="true"
            [hideGlobalFilter]="false"
            [showToolPanel]="true"
            [sideBar]="sideBar"
            [dropdownFilters]="dropdownFilters"
            [paginationAutoPageSize]="true"
			(cellValueChanged)="onCellValueChanged($event)"
        ></app-custom-table>
    </div>
</div>
